import { render, staticRenderFns } from "./exchangeInfo.vue?vue&type=template&id=efb8ad48&scoped=true&"
import script from "./exchangeInfo.vue?vue&type=script&lang=js&"
export * from "./exchangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./exchangeInfo.vue?vue&type=style&index=0&id=efb8ad48&scoped=true&lang=scss&"
import style1 from "./exchangeInfo.vue?vue&type=style&index=1&id=efb8ad48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8ad48",
  null
  
)

export default component.exports